import styled, { css } from 'styled-components';

import {
  TABLE_CELL_HEIGHT_PX,
  TABLE_HEADER_CELL_HEIGHT_PX,
} from '@qality/common-components/src/atoms/Table';

export const ContainerStyled = styled.div<{ minRows: number }>`
  isolation: isolate;
  position: relative;

  ${({ minRows = 0 }) => {
    return css`
      flex: 1 0
        ${minRows * TABLE_CELL_HEIGHT_PX + TABLE_HEADER_CELL_HEIGHT_PX}px;
    `;
  }};
`;

export const DropdownItemDeleteFromFolderStyled = styled.span`
  color: var(--ds-text-danger, var(--ds-fb-text-danger));
`;
